import { Controller } from "@hotwired/stimulus";
import { mustBeHtmlSelectElement } from "common/dom-utils";

/**
 * Sets --licensing-option-select-width from per-option widths (admin-measured).
 */
export default class extends Controller {
  static values = {
    optionWidths: Object,
    arrowPaddingPx: Number,
  };

  connect() {
    this.updateWidth();
  }

  updateWidth() {
    const select = mustBeHtmlSelectElement(
      this.element,
      "licensing option select"
    );
    const id = select.value;
    const widths = this.optionWidthsValue || {};
    let textWidthPx = widths[id];
    if (typeof textWidthPx !== "number") {
      return;
    }
    const widthPx = textWidthPx + this.arrowPaddingPxValue;
    select.style.setProperty("--licensing-option-select-width", `${widthPx}px`);
  }
}
